<template>
  <div class="co-area container">
    <com-title title="合作领域"></com-title>
    <ul class="columns is-mobile">
      <li class="column is-one-third-mobile" v-for="(item, index) in areas" :key="index">
        <div class="img">
          <img :src="item.icon" alt="" />
        </div>
        <span class="title">{{item.title}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  computed: {
    areas () {
      return [{
        icon: 'http://static.geekbang.org/infoq/5a225e0d1ec2c.png?imageView2/0/',
        title: '架构优化'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a27a2b7bc0ea.png?imageView2/0/',
        title: '微服务架构'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a225e0d7735b.png?imageView2/0/',
        title: '运维优化'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a27a368ecfed.png?imageView2/0/',
        title: '容器化调度'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a225e0cdc0fd.png?imageView2/0/',
        title: '大数据'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a225e0dcf0eb.png?imageView2/0/',
        title: '人工智能'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a225e0e910a1.png?imageView2/0/',
        title: '工程效率'
      }, {
        icon: 'http://static.geekbang.org/infoq/5a27a426460b9.png?imageView2/0/',
        title: '技术管理'
      }]
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/variable.sass'

+mobile
  .container
    width: 88vw

div.co-area
  border-top: 1px solid #e8e8e8
  border-bottom: 1px solid #e8e8e8
  padding-bottom: 65px
  .columns
   margin: 0
   +mobile
     flex-direction: row
     flex-wrap: wrap
   .column
     display: flex
     flex-direction: column
     text-align: center
     border-left: 1px solid #e8e8e8
     +mobile
       border: none
     &:last-child
       border-right: 1px solid #e8e8e8
       +mobile
         border: none
     .img
      height: 106px
      margin-bottom: 20px
      +mobile
        height: auto
        margin-bottom: 5px
      img
        width: 60%
        margin: 0 auto
        @media screen and (min-width: 1000px) and (max-width: 1582px)
          width: 45%
     span.title
       color: #353535
       // font-size: 20px
       @media screen and (min-width: 1000px) and (max-width: 1582px)
         font-size: 16px
         margin-top: -20px
       +mobile
         font-size: 14px
</style>
